"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmClient = exports.ConfirmClientActions = void 0;
var lodash_1 = __importDefault(require("lodash"));
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalCss_1 = require("../../globalCss");
var UrlUtil_1 = require("../../utils/UrlUtil");
var Common_1 = require("../Common");
var Header_1 = require("../Header");
var MainContent_1 = require("../MainContent");
var Pullout_1 = require("../Pullout");
var Select_1 = require("../Select");
var Description = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", "\n\tmargin-bottom: 30px;\n"], ["\n\t", "\n\tmargin-bottom: 30px;\n"])), globalCss_1.bodyCopyMedium);
Description.displayName = 'Description';
var CardBody = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tpadding-left: 20%;\n\tpadding-right: 20%;\n\tpadding-top: 60px;\n\n\ta {\n\t\t", "\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tpadding-left: 20%;\n\tpadding-right: 20%;\n\tpadding-top: 60px;\n\n\ta {\n\t\t", "\n\t}\n"])), globalCss_1.bodyCopyLink);
var CardFooter = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: absolute;\n\tright: 30px;\n\tbottom: 50px;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n"], ["\n\tposition: absolute;\n\tright: 30px;\n\tbottom: 50px;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n"])));
var CardMainContent = (0, styled_components_1.default)(MainContent_1.MainContent)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\twidth: 60%;\n"], ["\n\twidth: 60%;\n"])));
var SelectClientContainer = (0, styled_components_1.default)(Select_1.SelectHierarchy)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tz-index: 900;\n\tmargin-top: 30px;\n"], ["\n\tz-index: 900;\n\tmargin-top: 30px;\n"])));
SelectClientContainer.displayName = 'SelectClientContainer';
var defaultClient = {
    clientId: 0,
    name: '',
    unit: '',
};
var ConfirmClientActions;
(function (ConfirmClientActions) {
    ConfirmClientActions[ConfirmClientActions["None"] = 0] = "None";
    ConfirmClientActions[ConfirmClientActions["Redirect"] = 1] = "Redirect";
    ConfirmClientActions[ConfirmClientActions["SelectClient"] = 2] = "SelectClient";
    ConfirmClientActions[ConfirmClientActions["InvalidClient"] = 3] = "InvalidClient";
    ConfirmClientActions[ConfirmClientActions["NoAccess"] = 4] = "NoAccess";
})(ConfirmClientActions = exports.ConfirmClientActions || (exports.ConfirmClientActions = {}));
var ConfirmClient = /** @class */ (function (_super) {
    __extends(ConfirmClient, _super);
    function ConfirmClient(props) {
        var _this = _super.call(this, props) || this;
        _this.processMessage = function (event) {
            if (event.data === 'ClientConfirmed') {
                _this.setState({ clientConfirmed: true });
            }
        };
        _this.getTitle = function () {
            var confirmClientActions = _this.state.confirmClientActions;
            if (confirmClientActions === ConfirmClientActions.NoAccess) {
                return 'No Clients Available';
            }
            else {
                return 'Choose Your Client';
            }
        };
        _this.getConfirmButtonText = function () {
            var confirmClientActions = _this.state.confirmClientActions;
            if (confirmClientActions === ConfirmClientActions.NoAccess) {
                return 'Logout';
            }
            else {
                return 'Use Selected Client';
            }
        };
        _this.getClientId = function () {
            var clientId = -1;
            var user = _this.getUser();
            if (user && user.profile && user.profile.external_clientid) {
                clientId = parseInt(user.profile.external_clientid, 0);
            }
            return clientId;
        };
        _this.getUser = function () {
            var keys = Object.keys(localStorage);
            var key = lodash_1.default.find(keys, function (x) { return x.startsWith('oidc.user'); });
            var user = JSON.parse(localStorage.getItem(key));
            return user;
        };
        _this.handleRadioClientChange = function (value) {
            _this.setState({ selectedValue: value });
        };
        _this.hasAccessToClients = function () {
            var clients = _this.props.clients;
            return clients && clients.length > 0;
        };
        _this.isClientConfirmed = function () {
            return _this.state.clientConfirmed;
        };
        _this.onConfirm = function () {
            var _a;
            _this.setState({ confirmingClient: true });
            if (_this.hasAccessToClients()) {
                var returnUrl = UrlUtil_1.UrlUtil.getUrlParameter(location.search, 'ReturnUrl');
                var newClientId_1 = parseInt(_this.state.selectedValue, 0);
                var newClient = (_a = lodash_1.default.find(_this.props.clients, function (c) { return c.clientId === newClientId_1; })) !== null && _a !== void 0 ? _a : defaultClient;
                _this.props.ChangeClientContext(newClient, _this.props.identityServerUrl, returnUrl);
            }
            else {
                if (_this.props.logout) {
                    _this.props.logout(_this.props.userManager, _this.props.identityServerUrl);
                }
            }
        };
        _this.shouldChangeClientBeDisabled = function () {
            if (_this.state.confirmingClient) {
                return true;
            }
            if (_this.hasAccessToClients()) {
                return _this.state.selectedValue === undefined;
            }
            return false;
        };
        _this.transFormClients = function (clients) {
            return clients.map(function (client) {
                return {
                    id: client.clientId + '',
                    name: client.clientId + '',
                    displayText: client.name + ' - ' + client.unit,
                };
            });
        };
        _this.state = {
            clientConfirmed: false,
            confirmClientActions: ConfirmClientActions.None,
            confirmingClient: false,
            selectedValue: undefined,
        };
        return _this;
    }
    ConfirmClient.prototype.componentDidMount = function () {
        this.props.GetClients(this.props.userManagementBaseUrl);
        window.addEventListener('message', this.processMessage, false);
    };
    ConfirmClient.prototype.componentWillUnmount = function () {
        window.removeEventListener('message', this.processMessage);
    };
    ConfirmClient.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        var clients = this.props.clients;
        var user = this.getUser();
        if (user && user.profile && !prevProps.clientsLoaded && this.props.clientsLoaded) {
            var isClientConfirmed = this.isClientConfirmed();
            if (!this.hasAccessToClients()) {
                this.setState({ confirmClientActions: ConfirmClientActions.NoAccess });
            }
            else {
                var firstClient = clients[0];
                var selectedClient = lodash_1.default.find(clients, function (c) { return c.clientId === _this.getClientId(); });
                if (!selectedClient && !user.profile.impersonator_name) {
                    this.setState({ selectedValue: firstClient.clientId.toString(), confirmClientActions: ConfirmClientActions.InvalidClient });
                }
                else if (!isClientConfirmed && clients.length > 1) {
                    var selectedClientId = selectedClient ? selectedClient.clientId.toString() : firstClient.clientId.toString();
                    this.setState({ selectedValue: selectedClientId, confirmClientActions: ConfirmClientActions.SelectClient });
                }
                else {
                    this.identifyPendoMetaData(user, selectedClient);
                    var returnUrl_1 = UrlUtil_1.UrlUtil.getUrlParameter(location.search, 'ReturnUrl');
                    this.setState({ confirmClientActions: ConfirmClientActions.Redirect }, function () {
                        _this.props.Navigate(returnUrl_1 || '/');
                    });
                }
            }
        }
    };
    ConfirmClient.prototype.identifyPendoMetaData = function (user, client) {
        var pendo = window.pendo;
        if (pendo && user) {
            pendo.identify({
                visitor: {
                    id: user.profile.sid,
                    environment: process.env.REACT_APP_ENVIRONMENT || 'local',
                    email: user.profile.email,
                    name: user.profile.name,
                    roles: user.scope,
                    first_name: user.profile.preferred_username,
                    family_name: user.profile.family_name,
                },
                account: {
                    id: client === null || client === void 0 ? void 0 : client.clientId,
                    agentid: client === null || client === void 0 ? void 0 : client.unit,
                    full_client_name: client === null || client === void 0 ? void 0 : client.name,
                },
            });
        }
    };
    ConfirmClient.prototype.render = function () {
        var _this = this;
        var clients = this.props.clients;
        var confirmClientActions = this.state.confirmClientActions;
        var selectedClient = lodash_1.default.find(clients, function (c) { return c.clientId === _this.getClientId(); });
        return (React.createElement("div", null, confirmClientActions !== ConfirmClientActions.None && confirmClientActions !== ConfirmClientActions.Redirect && (React.createElement(React.Fragment, null,
            React.createElement(Header_1.Header, { menuModel: [], displayHeaderNavigation: true }),
            React.createElement(CardMainContent, null,
                React.createElement(Common_1.Card, null,
                    React.createElement(Common_1.CardHeader, { title: this.getTitle() }),
                    React.createElement(CardBody, null,
                        (confirmClientActions === ConfirmClientActions.InvalidClient ||
                            confirmClientActions === ConfirmClientActions.SelectClient) && (React.createElement(React.Fragment, null,
                            React.createElement(Description, null, "Use the dropdown below to confirm the client you want to use. The dropdown is defaulted to the last client you used, if still available. You can change this client later."),
                            !selectedClient && (React.createElement(Pullout_1.Pullout, { type: Pullout_1.PulloutType.Warning },
                                React.createElement("strong", null, "WARNING: "),
                                " You no longer have permission to the last client you used during the previous session. The dropdown is defaulted to the first client you have access to.")),
                            React.createElement(SelectClientContainer, { items: this.transFormClients(this.props.clients), selectSize: 'xlg', dropdownSize: 'md', showSearch: true, placeHolderText: 'Search', onRadioChange: this.handleRadioClientChange, selectedValue: this.state.selectedValue }))),
                        confirmClientActions === ConfirmClientActions.NoAccess && (React.createElement("div", null,
                            "You have no clients available to your account at this time. Either your permissions were revoked or the client is no longer active in the platform. If this is a mistake, please contact our",
                            ' ',
                            React.createElement("a", { href: 'https://msuitelink.com/support' }, "Client Service Team"),
                            "\u00A0for further assistance.")),
                        React.createElement(CardFooter, { className: 'col-12 text-right' },
                            React.createElement(Common_1.ButtonGroup, { type: 'column', reversed: false },
                                React.createElement(Common_1.Button, { id: 'ConfirmButton', color: 'primary', size: 'lg', disabled: this.shouldChangeClientBeDisabled(), onClick: this.onConfirm }, this.getConfirmButtonText()))))))))));
    };
    return ConfirmClient;
}(React.Component));
exports.ConfirmClient = ConfirmClient;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
